<template>
  <main-sidebar :name="name" :title="$t('filters')">
    <div class="p-4">
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="success" type="border" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'

export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return false
    }
  },
  data: () => ({
    filters: {},
    name: 'entry-filter',
    loading: {},
  }),
  methods: {
    clear() {
      const defaultFilter = {}
      this.filters = Object.assign({}, defaultFilter)
      this.$emit('input', this.filters)
      this.close()
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.filters = Object.assign({}, this.value)
    },
    setFilter() {
      this.$emit('input', this.filters)
      this.$emit('search')
      this.close()
    }
  },
  mixins: [loading],
  props: {
    value: {
      type: Object,
      default: () => ({
      }),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
}
</script>

<style>
</style>